export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10053.3f2b5a42.jpg";